import { render, staticRenderFns } from "./AlertBlock.vue?vue&type=template&id=2ee93a60&"
import script from "./AlertBlock.vue?vue&type=script&lang=js&"
export * from "./AlertBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports